// extracted by mini-css-extract-plugin
export var label = "_dp-1";
export var reminder = "_dp-0";